import { computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-02447c4c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-panel"
};
const _hoisted_2 = {
  class: "table-toolbar"
};
const _hoisted_3 = {
  key: 0,
  class: "batch-actions"
};
const _hoisted_4 = {
  class: "main-no"
};
const _hoisted_5 = {
  class: "sub-time"
};
const _hoisted_6 = {
  class: "amount"
};
const _hoisted_7 = {
  class: "clamp-text"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "pagination-content"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'TableList',
  props: {
    rows: null,
    loading: {
      type: Boolean
    },
    total: null,
    pageNum: null,
    pageSize: null,
    columns: null,
    selectedRows: null,
    selectedRowKeys: null,
    tableHeight: null,
    refundStateMap: null,
    complaintStateMap: null,
    toMoney: null,
    canUpdate: {
      type: Boolean
    }
  },
  emits: ["select", "open-detail", "export", "batch-change", "page-change"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    // 按三个 flag 拆分出每种批量操作实际可处理的子集（不满足的勾选行静默跳过）
    const refundRows = computed(() => props.selectedRows.filter(r => r.canRefund));
    const replyRows = computed(() => props.selectedRows.filter(r => r.canReply));
    const completeRows = computed(() => props.selectedRows.filter(r => r.canComplete));
    const countSuffix = n => n ? ` (${n})` : '';
    // 退款状态展示：未退款（10）与 -1 都不展示；其余仅用文字色，不带背景边框
    const REFUND_STATE_COLOR_MAP = {
      blue: '#1677FF',
      orange: '#FA8C16',
      red: '#FF4D4F',
      green: '#52C41A'
    };
    const HIDDEN_REFUND_STATES = new Set(['', '-1', '10']);
    const getRefundTag = state => {
      const key = state == null ? '' : String(state);
      if (HIDDEN_REFUND_STATES.has(key)) return null;
      const meta = props.refundStateMap[key];
      return {
        label: (meta === null || meta === void 0 ? void 0 : meta.label) || key,
        color: REFUND_STATE_COLOR_MAP[(meta === null || meta === void 0 ? void 0 : meta.color) || ''] || '#8C8C8C'
      };
    };
    const handleSelect = (keys, rows) => emit('select', keys, rows);
    const handlePageChange = (page, pageSize) => emit('page-change', page, pageSize);
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.canUpdate ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
        disabled: !_unref(refundRows).length,
        onClick: _cache[0] || (_cache[0] = $event => emit('batch-change', 'refund', _unref(refundRows)))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "rmb",
          "class-name": "batch-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 批量退款" + _toDisplayString(countSuffix(_unref(refundRows).length)), 1)]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_a_button, {
        disabled: !_unref(replyRows).length,
        onClick: _cache[1] || (_cache[1] = $event => emit('batch-change', 'reply', _unref(replyRows)))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "replay",
          "class-name": "batch-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 批量回复" + _toDisplayString(countSuffix(_unref(replyRows).length)), 1)]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_a_button, {
        disabled: !_unref(completeRows).length,
        onClick: _cache[2] || (_cache[2] = $event => emit('batch-change', 'finish', _unref(completeRows)))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "batchOver",
          "class-name": "batch-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 批量完结" + _toDisplayString(countSuffix(_unref(completeRows).length)), 1)]),
        _: 1
      }, 8, ["disabled"])])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
        onClick: _cache[3] || (_cache[3] = $event => emit('export'))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "export",
          "class-name": "download-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 导出 ")]),
        _: 1
      })]), _createVNode(_component_a_table, {
        "row-key": "complaintMainId",
        columns: __props.columns,
        "data-source": __props.rows,
        loading: __props.loading,
        pagination: false,
        scroll: {
          x: 1500,
          y: __props.tableHeight
        },
        "row-selection": {
          selectedRowKeys: __props.selectedRowKeys,
          onChange: handleSelect,
          preserveSelectedRowKeys: true
        },
        class: "wechat-complaint-table"
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _props$complaintStat;
          return [column.dataIndex === 'complaintId' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_4, _toDisplayString(record.transactionId || '-'), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(record.complaintTime || '-'), 1)], 64)) : column.dataIndex === 'amount' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_6, _toDisplayString(record.complaintOrderAmount || (record.amount ? `¥${__props.toMoney(record.amount)}` : '-')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([getRefundTag(record.refundState)].filter(Boolean), tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag.label,
              class: "refund-state-text",
              style: _normalizeStyle({
                color: tag.color
              })
            }, _toDisplayString(tag.label), 5);
          }), 128))], 64)) : column.dataIndex === 'complaintDetail' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 2,
            title: record.complaintDetail
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(record.complaintDetail || '-'), 1)]),
            _: 2
          }, 1032, ["title"])) : column.dataIndex === 'complaintState' ? (_openBlock(), _createBlock(_component_a_tag, {
            key: 3,
            color: (_props$complaintStat = __props.complaintStateMap[record.complaintState]) === null || _props$complaintStat === void 0 ? void 0 : _props$complaintStat.color
          }, {
            default: _withCtx(() => {
              var _props$complaintStat2;
              return [_createTextVNode(_toDisplayString(((_props$complaintStat2 = __props.complaintStateMap[record.complaintState]) === null || _props$complaintStat2 === void 0 ? void 0 : _props$complaintStat2.label) || record.complaintState || '-'), 1)];
            }),
            _: 2
          }, 1032, ["color"])) : column.dataIndex === 'lastOperator' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [!record.lastOperator && !record.operatorName ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            title: `待处理人：${record.pendingAssigneeNames || record.pendingHandler || '-'}`
          }, {
            default: _withCtx(() => [_createTextVNode(" - ")]),
            _: 2
          }, 1032, ["title"])) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.lastOperator || record.operatorName), 1))], 64)) : column.dataIndex === 'action' ? (_openBlock(), _createBlock(_component_a_button, {
            key: 5,
            type: "link",
            onClick: $event => emit('open-detail', record)
          }, {
            default: _withCtx(() => [_createTextVNode("处理")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", null, [_createTextVNode(" 共 "), _createElementVNode("span", null, _toDisplayString(__props.total), 1), _createTextVNode(" 条 ")]), _createVNode(_component_a_pagination, {
        current: __props.pageNum,
        "page-size": __props.pageSize,
        total: __props.total,
        "show-size-changer": true,
        "page-size-options": ['10', '20', '50', '100'],
        onChange: handlePageChange,
        onShowSizeChange: handlePageChange
      }, null, 8, ["current", "page-size", "total"])])]);
    };
  }
});